var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-textPrimary, #23024D)",
    fillRule: "evenodd",
    d: "M0 3a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6.333L3 16v-2a3 3 0 0 1-3-3zm7.383 7.506.149-2.233 3.835-3.674c.167-.157-.036-.244-.26-.087l-4.74 3.165-2.042-.678c-.444-.146-.452-.47.093-.696l7.984-3.26c.37-.147.693.087.572.685l-1.358 6.79c-.103.478-.37.597-.75.372L8.798 9.273 7.8 10.291c-.111.117-.203.215-.416.215",
    clipRule: "evenodd"
  })));
};
export default SvgTelegram;